export enum MaintenancePlanEnums {
  swEachUse = 0,
  swMaintenancePlan1 = 1,
  swMaintenancePlan2 = 2,
  swMaintenancePlan3 = 3,
  swMaintenancePlan4 = 4,
  swMaintenancePlan5 = 5,
  swMaintenancePlan6 = 6,
  swMaintenancePlan7 = 7
}